import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize analytics and error tracking
import { initPostHog } from "@/lib/posthog";
import { initSentry } from "@/lib/sentry";

initSentry();
initPostHog();

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(reg => console.log('[PWA] Service worker registered:', reg.scope))
            .catch(err => console.error('[PWA] Registration failed:', err));
    });
}
